import type { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import { isPlainObject } from 'lodash';
import { mergeDeepRight, reduce } from 'ramda';

/**
 * Better version of mergeStyles that allows for conditional styling.
 * Inspired by the `cn` utility from shadcn/ui for conditional styling.
 * Accepts any number of arguments, and returns a single style object.
 * Can also be used to conditionally apply styles based on boolean values.
 * Can be used to allow for additional styles to be passed in from props.
 *
 * simple example without conditionals:
 * @example
 * ```ts
 * ms(styles.base, additionalStylesFromProps)
 * ```
 *
 * example with conditionals
 * @example
 * ```ts
 * ms(
 *   styles.base,
 *   isActive && styles.active,
 *   disabled && styles.disabled
 * )
 * ```
 */
export const ms = (...args: (object | boolean | null | undefined)[]): FelaCSS =>
  reduce(
    mergeDeepRight,
    {},
    args.filter((arg): arg is object => arg !== null && arg !== undefined && isPlainObject(arg)),
  );
